// NATIVE

// INSTALLED

// CUSTOM
import { checkingPreload, unCheckingPreload } from '../loading';
import { setContratosListRedux, setContratoRedux } from './contratos.slice';
import { QueryPagination } from '../../commons/interfaces';
import {
  getAllContratosService,
  createContratoService,
  updateContratoService,
  getContratoDetailService,
  deleteContratoService,
  restoreContratoService,
} from '../../services/contratos.service';

export const getAllContratosStore =
  (query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await getAllContratosService(query);

      if (response?.ok) {
        await dispatch(setContratosListRedux(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const getContratoDetailStore = (id: string) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await getContratoDetailService(id);

    if (response?.ok) {
      dispatch(setContratoRedux(response.data));
    }

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const saveContratoStore = (data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await createContratoService(data);

    if (response?.ok) {
      dispatch(setContratosListRedux(response.data));
    }

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const updateContratoStore = (id: string, data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await updateContratoService(id, data);

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const deleteContratoStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await deleteContratoService(id, query);

      if (response?.ok) {
        dispatch(setContratosListRedux(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const restoreContratoStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await restoreContratoService(id, query);

      if (response?.ok) {
        dispatch(setContratosListRedux(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };
